import styled from 'styled-components'

import { TextParagraphStyles } from '@components/atoms/Text/Text.styles'

export const Root = styled.div``

export const TextLink = styled.a`
  font-weight: bold;
`
export const Address = styled.address`
  ${TextParagraphStyles()}
`
